import { useRouteError } from "react-router-dom";

const ScanError = () => {
  const err = useRouteError();
  console.error(err);
  return (
    <div className="h-screen bg-white flex flex-col justify-center items-center">
      <img src={process.env.PUBLIC_URL + "/images/failure.gif"} alt="failure icon" className="w-48 mx-auto" />
      <p className="mt-3 text-primary text-center">
        Scan Failed!
        <br />
        Please try again.
      </p>
      <button
        className="mt-8 px-4 py-2 rounded-lg bg-red-500 text-white text-sm font-medium"
        type="button"
        onClick={() => {
          window?.ReactNativeWebView?.postMessage?.("event:::goBack");
        }}
      >
        Go Back
      </button>
    </div>
  );
};
export default ScanError;
